import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useEffect, useRef, useState } from 'react';

export const useFullScreenBodyLock = () => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const toggleBodyScroll = () => {
      if (!ref.current) {
        return;
      }

      if (isFullScreen) {
        disableBodyScroll(ref.current, {
          allowTouchMove: (el) => {
            const dataNoScroll = el.getAttribute('scroll-lock');
            if (dataNoScroll) {
              return false;
            }
            return ref.current?.contains(el) || false;
          }
        });
        return;
      }

      enableBodyScroll(ref.current);
    };

    toggleBodyScroll();
    return () => clearAllBodyScrollLocks();
  }, [isFullScreen, ref]);

  useEffect(() => {
    const closeOnEscKey = (e: KeyboardEvent) => {
      if (!isFullScreen || e.key !== 'Escape') {
        return;
      }

      setIsFullScreen(false);
    };

    document.addEventListener('keydown', closeOnEscKey);

    return () => document.removeEventListener('keydown', closeOnEscKey);
  }, [isFullScreen]);

  return { isFullScreen, setIsFullScreen, ref } as const;
};
